import React from 'react';
import {Route, Redirect} from 'react-router-dom';
import { client } from '../Client';

const MatchWhenLoggedIn = ({ component, ...rest }) => (
    <Route {...rest} render={(props) => (
        client.isLoggedIn() ? (
            React.createElement(component, props)
                //<Component {...props} instance={instance} tipo={tipo} />
            ):(
                <Redirect to={{
                    pathname: '/login',
                    state: { from: props.location },
                }} />
            ) )} />
);

export default MatchWhenLoggedIn;



/** WEBPACK FOOTER **
 ** ./src/components/MatchWhenLoggedIn.js
 **/